<div id="quote-actions-container">
  <div class="flex gap-4"
       [class.hidden]="!hasPermission(Permission.QuoteActions) || status() != '2'">
    <button data-modal-toggle="quote-modal"
            data-modal-target="quote-modal"
            type="button"
            class="min-h-12 btn-accept"
            (click)="handleButtonClick(QuoteButtonType.Approve)">Approve
    </button>
    <button data-modal-toggle="quote-modal"
            data-modal-target="quote-modal"
            type="button"
            class="min-h-12 btn-decline"
            (click)="handleButtonClick(QuoteButtonType.Decline)">Decline
    </button>
    <button data-modal-toggle="quote-modal"
            data-modal-target="quote-modal"
            type="button"
            class="min-h-12 btn-ask-change ml-14"
            (click)="handleButtonClick(QuoteButtonType.RequestChanges)">Request Changes
    </button>
  </div>

  <div id="quote-modal"
       tabindex="-1"
       class="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full backdrop-blur-xl">
    <div id="quote-modal-dialog" class="relative w-2/3 max-w-2xl max-h-full">
      <!-- Modal content -->
      <div id="quote-modal-content" class="relative bg-white rounded-lg shadow">
        <!-- Modal header -->
        <div id="quote-modal-header" class="flex items-baseline justify-between p-2 border-b rounded-t">
          <h3 id="quote-modal-title" class="text-xl font-semibold text-gray-900 dark:text-white">
            {{ getTitle() }}
          </h3>
          <button id="quote-modal-close-btn"
                  type="button"
                  class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                  data-modal-hide="quote-modal">
            <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
            </svg>
            <span class="sr-only">Close modal</span>
          </button>
        </div>

        <!-- Modal body -->
        <div id="quote-modal-body" class="p-4 space-y-3">
          <!-- Approve section -->
          @if (type === QuoteButtonType.Approve) {
            <div id="quote-approve-section" class="normal-text">
              Please confirm that you approve this quote. ReNew Biomedical Services will be notified that you have
              authorized them to perform this work.
              <div id="quote-po-number-container" class="mt-2">
                <div id="quote-po-number-label" class="input-label-custom">PO Number <span
                  [hidden]="!po_number_required" class="text-red-500">*</span></div>
                <input id="quote-po-number-input"
                       type="text"
                       placeholder="Enter PO number"
                       [formControl]="po_number_requiredControl"
                       [required]="po_number_required"
                       class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                       [(ngModel)]="poNumber">
                @if (po_number_requiredControl.invalid && (po_number_requiredControl.dirty || po_number_requiredControl.touched)) {
                  <div id="quote-po-number-error" class="flex gap-2 text-xs pt-2 text-red-500">
                    <custom-icon size="14.4px" iconName="fa-triangle-exclamation"/>
                    <span>PO Number is required.</span>
                  </div>
                }
              </div>
              <div id="quote-attachments-container" class="w-[48%] input-wrap-custom">
                <div id="quote-attachments-label" class="input-label-custom">Attachment(s) <span
                  [hidden]="!po_attachments_required" class="text-red-500">*</span></div>
                <div class="input-value-custom">
                  <input id="quote-file-input"
                         type="file"
                         class="hidden"
                         [formControl]="po_attachments_requiredControl"
                         [required]="po_attachments_required"
                         (change)="onPhotoSelected($event)"
                         multiple/>
                  <label id="quote-file-browse-btn"
                         for="quote-file-input"
                         class="flex gap-1 justify-center items-center w-[300px] p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 cursor-pointer">
                    <custom-icon size="19px" iconName="fa-triangle-exclamation"/>
                    <span>Browse</span>
                  </label>
                  @if (po_attachments_requiredControl.invalid && (po_attachments_requiredControl.dirty || po_attachments_requiredControl.touched)) {
                    <div id="quote-attachments-error"
                         class="text-xs pt-2 text-red-500">
                      <custom-icon size="14.4px" iconName="fa-triangle-exclamation"/>
                      <span>PO Attachment(s) is required.</span>
                    </div>
                  }
                </div>
              </div>
              <div id="quote-attachments-preview" class="flex flex-wrap">
                @for (attachment of attachments; track $index; let i = $index) {
                  <div
                    id="quote-attachment-item-{{i}}"
                    class="photo-item w-[300px] h-[300px] flex flex-col items-center border border-gray-300 rounded-md m-2 p-2">
                    @if (isSupportedFileType(attachment.fileName)) {
                      <img id="quote-attachment-image-{{i}}"
                           [src]="attachment.content"
                           alt="Uploaded Photo"
                           class="object-contain w-200 h-[200px] rounded-md"/>
                    }
                    @if (!isSupportedFileType(attachment.fileName)) {
                      <img id="quote-attachment-file-icon-{{i}}"
                           src="https://www.iconpacks.net/icons/2/free-file-icon-1453-thumb.png"
                           alt="Unsupported File Type"
                           class="object-contain w-200 h-[200px] rounded-md"/>
                    }
                    <span id="quote-attachment-filename-{{i}}"
                          class="block truncate w-[200px] text-center">{{ attachment.fileName }}</span>
                    <button id="quote-attachment-remove-btn-{{i}}"
                            (click)="removePhoto(i)"
                            class="remove-button mt-auto">
                      <svg class="w-6 h-6 text-black" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                           viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"/>
                      </svg>
                    </button>
                  </div>
                }
              </div>
            </div>
          }

          <!-- Decline section -->
          @if (type === QuoteButtonType.Decline) {
            <div id="quote-decline-section" class="font-normal">
              Please share your reasons for declining:
              <div class="mt-2">
                <textarea id="quote-decline-reason"
                          class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                          [(ngModel)]="reasonDecline"></textarea>
              </div>
            </div>
          }

          <!-- Request Changes section -->
          @if (type === QuoteButtonType.RequestChanges) {
            <div id="quote-request-changes-section" class="font-normal">
              Please specify what changes you would like to make to the Quote:
              <div class="mt-2">
                <textarea id="quote-changes-needed"
                          (change)="getButtonDisable()"
                          class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                          [(ngModel)]="changesNeeded"></textarea>
              </div>
            </div>
          }
        </div>

        <!-- Modal footer -->
        <div id="quote-modal-footer"
             class="flex items-center justify-end p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600 space-x-4">
          <button id="quote-modal-cancel-btn"
                  class="button-font text-black border font-medium rounded-lg text-base px-5 py-2.5 text-center focus:z-10"
                  data-modal-hide="quote-modal">Cancel
          </button>
          @if (!getButtonDisable()) {
            <button id="quote-modal-submit-btn"
                    data-modal-hide="quote-modal"
                    type="submit"
                    class="{{getButtonColor()}}"
                    (click)="handleSendClick()">{{ getButtonText() }}
            </button>
          }
          @if (getButtonDisable()) {
            <button id="quote-modal-submit-disabled-btn"
                    title="Changes to Quote is required"
                    disabled
                    data-modal-hide="quote-modal"
                    type="submit"
                    class="{{getButtonColor()}} bg-gray-500 text-white border-gray-500"
                    (click)="handleSendClick()">{{ getButtonText() }}
            </button>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Loading overlay -->
  @if (isLoading) {
    <loading-overlay message="Please wait while the request is being processed..."/>
  }
</div>
